<template>
  <!-- 看板 -->
  <div class="bulletinBoard">
    <div class="top_centers">
      <div class="top flex">
        <div>
          数据更新至 {{ curettime }}
        </div>
        <div class="top_center flex">
          <div class="top_center_one">
            <p class="sz12 co70">国家/地区</p>
            <el-dropdown trigger="click" @visible-change='iconclick(1)'>
              <div class="sz16 scect flex">{{ timname }}<i v-if="iconstuts" class="el-icon-caret-right"></i><i v-else
                  class="el-icon-caret-bottom"></i></div>
              <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                <div class="nologins cursor">
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStutszs == 1 ? 'listba' : ''">{{ timname }}
                    </div>
                  </el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="top_center_two">
            <p class="sz12 co70">币种</p>
            <el-dropdown trigger="click" @visible-change='iconclick(2)'>
              <div class="sz16 scect flex">美元<i v-if="iconstuts2" class="el-icon-caret-right"></i><i v-else
                  class="el-icon-caret-bottom"></i></div>
              <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                <div class="nologins cursor">
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStutszs == 1 ? 'listba' : ''">美元 </div>
                  </el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </div>
      </div>

      <div class="list flex">
        <div class="list_li">
          <div style="font-size:16px;" class="list_top sz16">昨日点击量</div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">{{ parseFloat(hitsList.zuoriclicks).toLocaleString() }}
            </div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="hitsList.dayhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="hitsList.dayhuanbi.indexOf('-') == -1" style="font-size:20px;" class="co9b">
                  {{ hitsList.dayhuanbi }}</p>
                <p v-else style="font-size:20px;" class="co65">{{ hitsList.dayhuanbi.substr(1) }}</p>
                <p style="font-size:12px;" class=" co70">环比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">前日点击量：{{ parseFloat(hitsList.qianriclicks).toLocaleString() }}
          </div>
        </div>
        <div class="list_li">
          <div style="font-size:16px;" class="list_top flex sz16">本周点击量 <p class="ru50 center sz12"
              @mouseenter="mouseover(1)" @mouseleave="mouseout">?</p><span class="sz12" v-if="tabsalass == 1">周一 ~
              昨日数据</span></div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">{{ parseFloat(hitsList.benzhouclicks).toLocaleString() }}
            </div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="hitsList.weekhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="hitsList.weekhuanbi.indexOf('-') == -1" style="font-size:20px;" class="co9b">
                  {{ hitsList.weekhuanbi }}</p>
                <p v-else style="font-size:20px;" class="co65">{{ hitsList.weekhuanbi.substr(1) }}</p>
                <p style="font-size:12px;" class=" co70">环比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">
            上周同期点击量：{{ parseFloat(hitsList.shangzhouclicks).toLocaleString() }}</div>
        </div>
        <div class="list_li">
          <div style="font-size:16px;" class="list_top flex sz16">本月点击量 <p class="ru50 center sz12"
              @mouseenter="mouseover(2)" @mouseleave="mouseout">?</p><span class="sz12" v-if="tabsalass == 2">本月1日 ~
              昨日数据</span></div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">{{ parseFloat(hitsList.benyueclicks).toLocaleString() }}
            </div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="hitsList.monthhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="hitsList.monthhuanbi.indexOf('-') == -1" class="co9b" style="font-size:20px;">
                  {{ hitsList.monthhuanbi }}</p>
                <p v-else style="font-size:20px;" class="co65">{{ hitsList.monthhuanbi.substr(1) }}</p>
                <p style="font-size:12px;" class=" co70">环比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">
            上月同期点击量：{{ parseFloat(hitsList.shangyueclicks).toLocaleString() }}</div>
        </div>
        <div class="list_li">
          <div style="font-size:16px;" class="list_top flex sz16">本年总点击量 <p class="ru50 center sz12"
              @mouseenter="mouseover(3)" @mouseleave="mouseout">?</p><span class="sz12" v-if="tabsalass == 3">本年1月1日 ~
              昨日数据</span></div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">{{ parseFloat(hitsList.jinnianclicks).toLocaleString() }}
            </div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="hitsList.yearclickhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="hitsList.yearclickhuanbi.indexOf('-') == -1" style="font-size:20px;" class="co9b">
                  {{ hitsList.yearclickhuanbi }}</p>
                <p v-else style="font-size:20px;" class="co65">{{ hitsList.yearclickhuanbi.substr(1) }}</p>
                <p style="font-size:12px;" class=" co70">同比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">
            去年同期点击量：{{ parseFloat(hitsList.shangnianclicks).toLocaleString() }}</div>
        </div>
      </div>
      <div class="list flex">
        <div class="list_li">
          <div style="font-size:16px;" class="list_top sz16">昨日分销金额</div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">{{
              parseFloat(distribution.zuoriamount).toLocaleString()
            }}
            </div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="distribution.dayhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="distribution.dayhuanbi.indexOf('-') == -1" style="font-size:20px;" class="co9b">
                  {{ distribution.dayhuanbi }}</p>
                <p v-else style="font-size:20px;" class="co65">{{ distribution.dayhuanbi.substr(1) }}</p>
                <p style="font-size:12px;" class=" co70">环比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">
            前日分销金额：{{ parseFloat(distribution.qianriamount).toLocaleString() }}</div>
        </div>
        <div class="list_li">
          <div style="font-size:16px;" class="list_top flex sz16">本周分销金额 <p class="ru50 center sz12"
              @mouseenter="mouseover(4)" @mouseleave="mouseout">?</p><span class="sz12" v-if="tabsalass == 4">周一 ~
              昨日数据</span></div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">
              {{ parseFloat(distribution.benzhouamount).toLocaleString() }}</div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="distribution.weekhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="distribution.weekhuanbi.indexOf('-') == -1" style="font-size:20px;" class="co9b">
                  {{ distribution.weekhuanbi }}</p>
                <p v-else style="font-size:20px;" class="co65">{{ distribution.weekhuanbi.substr(1) }}</p>
                <p style="font-size:12px;" class=" co70">环比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">
            上周同期分销金额：{{ parseFloat(distribution.shangzhouamount).toLocaleString() }}</div>
        </div>
        <div class="list_li">
          <div style="font-size:16px;" class="list_top flex sz16">本月分销金额 <p class="ru50 center sz12"
              @mouseenter="mouseover(5)" @mouseleave="mouseout">?</p><span class="sz12" v-if="tabsalass == 5">本月1日 ~
              昨日数据</span></div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">
              {{ parseFloat(distribution.benyueamount).toLocaleString() }}</div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="distribution.monthhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="distribution.monthhuanbi.indexOf('-') == -1" style="font-size:20px;" class="co9b">
                  {{ distribution.monthhuanbi }}</p>
                <p v-else style="font-size:20px;" class="co65">{{ distribution.monthhuanbi.substr(1) }}</p>
                <p style="font-size:12px;" class=" co70">环比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">
            上月同期分销金额：{{ parseFloat(distribution.shangyueamount).toLocaleString() }}</div>
        </div>
        <div class="list_li">
          <div style="font-size:16px;" class="list_top flex sz16">今年总分销金额 <p class="ru50 center sz12"
              @mouseenter="mouseover(6)" @mouseleave="mouseout">?</p><span class="sz12" v-if="tabsalass == 6">本年1月1日 ~
              昨日数据</span></div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">
              {{ parseFloat(distribution.bennianamount).toLocaleString() }}</div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="distribution.yearhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="distribution.yearhuanbi.indexOf('-') == -1" style="font-size:20px;" class="co9b">
                  {{ distribution.yearhuanbi }}</p>
                <p v-else style="font-size:20px;" class="co65">{{ distribution.yearhuanbi }}</p>
                <p style="font-size:12px;" class=" co70">同比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">
            去年同期分销金额：{{ parseFloat(distribution.shangnianamount).toLocaleString() }}</div>
        </div>
      </div>
      <div class="list flex">
        <div class="list_li">
          <div style="font-size:16px;" class="list_top flex sz16">昨日出单量 </div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">{{ parseFloat(issue.zuoricount).toLocaleString() }}</div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="issue.dayhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="issue.dayhuanbi.indexOf('-') == -1" class="co9b" style="font-size:20px;">{{ issue.dayhuanbi }}
                </p>
                <p v-else style="font-size:20px;" class="co65">{{ issue.dayhuanbi.substr(1) }}</p>
                <p style="font-size:12px;" class=" co70">环比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">前日出单量：{{ parseFloat(issue.qianricount).toLocaleString() }}
          </div>
        </div>
        <div class="list_li">
          <div style="font-size:16px;" class="list_top flex sz16">本周出单量 <p class="ru50 center sz12"
              @mouseenter="mouseover(7)" @mouseleave="mouseout">?</p><span class="sz12" v-if="tabsalass == 7">周一 ~
              昨日数据</span></div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">{{ parseFloat(issue.benzhoucount).toLocaleString() }}
            </div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="issue.weekhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="issue.weekhuanbi.indexOf('-') == -1" style="font-size:20px;" class="co9b">{{
                  issue.weekhuanbi
                }}
                </p>
                <p v-else style="font-size:20px;" class="co65">{{ issue.weekhuanbi.substr(1) }}</p>
                <p style="font-size:12px;" class=" co70">环比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">上周同期出单量：{{ parseFloat(issue.shangzhoucount).toLocaleString() }}
          </div>
        </div>
        <div class="list_li">
          <div style="font-size:16px;" class="list_top flex sz16">本月出单量 <p class="ru50 center sz12"
              @mouseenter="mouseover(8)" @mouseleave="mouseout">?</p><span class="sz12" v-if="tabsalass == 8">本月1日 ~
              昨日数据</span></div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">{{ parseFloat(issue.benyuecount).toLocaleString() }}
            </div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="issue.monthhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="issue.monthhuanbi.indexOf('-') == -1" style="font-size:20px;" class="co9b">
                  {{ issue.monthhuanbi }}</p>
                <p v-else style="font-size:20px;" class="co65">{{ issue.monthhuanbi.substr(1) }}</p>
                <p style="font-size:12px;" class=" co70">环比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">上月同期出单量：{{ parseFloat(issue.shangyuecount).toLocaleString() }}
          </div>
        </div>
        <div class="list_li">
          <div style="font-size:16px;" class="list_top flex sz16">今年总出单量 <p class="ru50 center sz12"
              @mouseenter="mouseover(9)" @mouseleave="mouseout">?</p><span class="sz12" v-if="tabsalass == 9">本年1月1日 ~
              昨日数据</span></div>
          <div class="list_center flex">
            <div style="font-size:18px;" class="p1 yb font_bo">{{ parseFloat(issue.benniancount).toLocaleString() }}
            </div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="issue.yearhuanbi.indexOf('-') == -1" src="@/assets/img/dpt/ss.png" alt="">
                <img v-else src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p v-if="issue.yearhuanbi.indexOf('-') == -1" style="font-size:20px;" class="co9b">{{
                  issue.yearhuanbi
                }}
                </p>
                <p v-else style="font-size:20px;" class="co65">{{ issue.yearhuanbi.substr(1) }}</p>
                <p style="font-size:12px;" class=" co70">环比计算</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">去年同期出单量：{{ parseFloat(issue.shangniancount).toLocaleString() }}
          </div>
        </div>
      </div>
      <div class="zwf"></div>
      <div class="top2 flex">
        <div class="top_center1 flex">
          <div class="top_center_two">
            <p class="sz12 co70">时间</p>
            <el-dropdown trigger="click" @visible-change='iconclick(3)'>
              <div class="sz16 scect flex">{{ setime }}<i v-if="iconstuts3" class="el-icon-caret-right"></i><i v-else
                  class="el-icon-caret-bottom"></i></div>
              <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                <div class="nologins cursor">
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStuts == 1 ? 'listba' : ''"
                      @click="listclick(1)">
                      过去7天</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStuts == 2 ? 'listba' : ''"
                      @click="listclick(2)">
                      过去30天</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStuts == 3 ? 'listba' : ''"
                      @click="listclick(3)">
                      过去90天</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStuts == 4 ? 'listba' : ''"
                      @click="listclick(4)">
                      过去1年</div>
                  </el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="echart baff ru5">
        <div class="charts">
          <div id="myChart1" style="margin-top;10px;" :style="{ width: '100%', height: '100%', marginTop: '10px' }"></div>
        </div>
        <div class="broken4 flex">
          <p class="p1 cursor" :class="p0stuts == 1 ? 'pico' : ''" @click="pzero(1)">数据概览</p>
          <p class="p2"></p>
          <p class="p3 cursor" :class="p0stuts == 2 ? 'pico' : ''" @click="pzero(2)">重复订单</p>
        </div>
      </div>
      <div class="proportion flex">
        <div class="proportion_left ru5">
          <div class="proportion_left_c ru5">
            <div class="top flex">
              <div class="top_center flex">
                <div class="top_center_one">
                  <p class="sz12 co70">联盟平台</p>
                  <el-dropdown trigger="click" @visible-change='iconclick(4)'>
                    <div class="sz16 scect flex">{{ Linkname }}<i v-if="iconstuts4" class="el-icon-caret-right"></i><i
                        v-else class="el-icon-caret-bottom"></i></div>
                    <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                      <div class="nologins cursor">
                        <el-dropdown-item v-for="(item, index) in hasplist" :key="index">
                          <div class="nologins_list center cursor" :class="coksstuts == index ? 'listba' : ''"
                            @click="nameclick(item, index)">{{ item.channelTypeValue }}</div>
                        </el-dropdown-item>
                        <!-- <el-dropdown-item>
                          <div class="nologins_list center cursor" :class="coksstuts == 2 ?'listba':''" @click="nameclick(2)">ShareASale</div>
                        </el-dropdown-item> -->
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="top_center_two">
                  <p class="sz12 co70">时间</p>
                  <el-dropdown trigger="click" @visible-change='iconclick(5)'>
                    <div class="sz16 scect flex">{{ comime }}<i v-if="iconstuts5" class="el-icon-caret-right"></i><i
                        v-else class="el-icon-caret-bottom"></i></div>
                    <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                      <div class="nologins cursor">
                        <el-dropdown-item>
                          <div class="nologins cursor">
                            <el-dropdown-item>
                              <div class="nologins_list center cursor" :class="listStutscf == 1 ? 'listba' : ''"
                                @click="comclick(1)">过去7天</div>
                            </el-dropdown-item>
                            <el-dropdown-item>
                              <div class="nologins_list center cursor" :class="listStutscf == 2 ? 'listba' : ''"
                                @click="comclick(2)">过去30天</div>
                            </el-dropdown-item>
                            <el-dropdown-item>
                              <div class="nologins_list center cursor" :class="listStutscf == 3 ? 'listba' : ''"
                                @click="comclick(3)">过去90天</div>
                            </el-dropdown-item>
                            <el-dropdown-item>
                              <div class="nologins_list center cursor" :class="listStutscf == 4 ? 'listba' : ''"
                                @click="comclick(4)">过去1年</div>
                            </el-dropdown-item>
                          </div>
                        </el-dropdown-item>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="imgs baff flex">
            <div class="w50">
              <div style="font-size:14px;" class="title_text font_bo center">{{ titleName }}</div>
              <div class="echatr">
                <div id="myChart2" :style="{ width: '100%', height: '100%' }"></div>
              </div>
            </div>
            <div class="imgs_inpusts flex">
              <div>
                <div class="broken3_one flex">
                  <div class="broken_input cursor">
                    <input id="turn3" v-model="subcheckboxs" @click="ckbox" type="checkbox" /><label for="turn3"></label>
                  </div>
                  <div>
                    <p style="font-size:12px" class="oocode">重复金额 / 总分销金额</p>
                    <p style="font-size:16px">{{ parseFloat(ShareAsale.repeatamount).toLocaleString() }} /
                      {{ parseFloat(ShareAsale.totaltransamount).toLocaleString() }}</p>
                  </div>
                </div>
                <div class="broken3_two flex">
                  <div class="broken_input cursor">
                    <input id="turn4" v-model="subcheckboxtwo" @click="ckboxtwo" type="checkbox" /><label
                      for="turn4"></label>
                  </div>
                  <div>
                    <p style="font-size:12px" class="oocode">重复订单数 / 总订单数</p>
                    <p style="font-size:16px">{{ parseFloat(ShareAsale.repeatordernum).toLocaleString() }} /
                      {{ parseFloat(ShareAsale.totalordernum).toLocaleString() }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="proportion_righ ru5">
          <div class="proportion_left_c ru5">
            <div class="top flex">
              <div class="top_center flex">
                <div class="top_center_two">
                  <p class="sz12 co70">时间</p>
                  <el-dropdown trigger="click" @visible-change='iconclick(6)'>
                    <div class="sz16 scect flex">{{ distributionName }}<i v-if="iconstuts6"
                        class="el-icon-caret-right"></i><i v-else class="el-icon-caret-bottom"></i></div>
                    <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                      <div class="nologins cursor">
                        <el-dropdown-item>
                          <div class="nologins_list center cursor" :class="distributionStuts == 1 ? 'listba' : ''"
                            @click="distributionclik(1)">过去7天</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="nologins_list center cursor" :class="distributionStuts == 2 ? 'listba' : ''"
                            @click="distributionclik(2)">过去30天</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="nologins_list center cursor" :class="distributionStuts == 3 ? 'listba' : ''"
                            @click="distributionclik(3)">过去90天</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="nologins_list center cursor" :class="distributionStuts == 4 ? 'listba' : ''"
                            @click="distributionclik(4)">过去1年</div>
                        </el-dropdown-item>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="imgs baff">
            <div class="bott_list_top w100 flex">
              <div style="font-size:14px;" class="font_bo titles">联盟客类型分销占比</div>
              <div class="flex botts">
                <p style="font-size:12px;" class="p1 cursor" :class="p1stuts == 1 ? 'pico' : ''" @click="picos(1)">分销金额
                </p>
                <p style="font-size:12px;" class="p2"></p>
                <p style="font-size:12px;" class="p3 cursor" :class="p1stuts == 2 ? 'pico' : ''" @click="picos(2)">分销订单数
                </p>
              </div>
            </div>
            <div class="w100 bott_list3">
              <div id="myChart3" :style="{ width: '100%', height: '100%' }"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bott">
        <div class="tops flex">
          <div class="top_center flex">
            <div class="top_center_two">
              <p class="sz12 co70">时间</p>
              <el-dropdown trigger="click" @visible-change='iconclick(7)'>
                <div class="sz16 scect flex">{{ tabName }}<i v-if="iconstuts7" class="el-icon-caret-right"></i><i v-else
                    class="el-icon-caret-bottom"></i></div>
                <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                  <div class="nologins cursor">
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="tableStuts == 1 ? 'listba' : ''"
                        @click="tabclick(1)">过去7天</div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="tableStuts == 2 ? 'listba' : ''"
                        @click="tabclick(2)">过去30天</div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="tableStuts == 3 ? 'listba' : ''"
                        @click="tabclick(3)">过去90天</div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="tableStuts == 4 ? 'listba' : ''"
                        @click="tabclick(4)">过去1年</div>
                    </el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div class="bott_list ru5 baff">
          <div class="bott_list_top w100 flex">
            <div style="font-size:16px;" class="font_bo">联盟客分销金额TOP 5</div>
            <div class="flex botts">
              <p style="font-size:12px;" class="p1 cursor" :class="p2stuts == 1 ? 'pico' : ''" @click="psick(1)">分销金额
              </p>
              <p style="font-size:12px;" class="p2"></p>
              <p style="font-size:12px;" class="p3 cursor" :class="p2stuts == 2 ? 'pico' : ''" @click="psick(2)">分销订单数
              </p>
            </div>
          </div>
          <div class="bott_list_center w100">
            <div style="font-size:12px;" class="toop_title w100 flex">
              <p class="one1">序号</p>
              <p class="fooer2">联盟客姓名</p>
              <p class="one">联盟客ID</p>
              <p class="fooer">推广网站</p>
              <p class="one">分销金额</p>
              <p class="one">分销订单数</p>
              <p class="one">联盟客类型</p>
              <p class="one">联盟客平台</p>
            </div>
            <div v-if="tabList.length">
              <div style="font-size:12px;" class="toop_center w100 flex" v-for="(item, index) in tabList" :key="index">
                <p class="one1">{{ index + 1 }}</p>
                <p class="fooer2">{{ item.website }}</p>
                <p class="one">{{ item.affiliateid }}</p>
                <p class="fooer">{{ item.affiliatewebsite }}</p>
                <p class="one">{{ parseFloat(item.transamount).toLocaleString() }}</p>
                <p class="one">{{ item.transcount }}</p>
                <p style="padding-right: 10px;box-sizing: border-box;" class="one sunbiole">
                  <el-popover placement="top-start" trigger="hover">
                    <div style="color:#000">{{ item.tags }}</div>
                    <span slot="reference">{{ item.tags }}</span>
                  </el-popover>
                </p>
                <p class="one">{{ item.platformtype }}</p>
              </div>
            </div>
            <div style="font-size:12px;justify-content: center;" class="toop_center w100 flex center" v-else>
              暂无数据
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <icp></icp> -->
  </div>
</template>
<script>
import { QUERYCLICKSDETAIL, QUERYAMOUNTDATADETAIL, QUERYORDERDATADETAIL, QUERYAMOUNTCOUNTCHART, QUERYREPEATORDERCHART, QUERYTOP5DATA, QUERYAFFLIATETYPERATE, QUERYREPEATRATE, HASPLATFORMLIST } from '../../api/platform'
import icp from '../icp/icp.vue'
import util from '@/utils/util'
export default {
  components: {
    icp
  },
  data() {
    return {
      listStutszs: 1,
      timname: '美国(UTC-5)',
      inputStsts: 1,
      inputStsts2: 1,
      subcheck: true,
      subchecktwo: true,
      p0stuts: 1,
      p1stuts: 1,
      p2stuts: 1,
      listStuts: 1,
      listStutscf: 1,
      p0stutscon: 1,
      hitsList: {
        dayhuanbi: '',
        weekhuanbi: '',
        monthhuanbi: '',
        yearclickhuanbi: '',
      }, //点击量
      distribution: {
        dayhuanbi: '',
        weekhuanbi: '',
        monthhuanbi: '',
        yearhuanbi: '',
      },//分销金额
      issue: {
        dayhuanbi: '',
        weekhuanbi: '',
        monthhuanbi: '',
        yearhuanbi: '',
      }, // 出单量
      time: [], // 时间
      setime: '过去7天',
      comime: '过去7天',
      avantLinkList: [],
      comStuts: 0,
      Linkname: '选择',
      namestuts: 0,
      ShareAsale: {
        repeatamount: '',
        totaltransamount: '',
        repeatordernum: '',
        totalordernum: '',
      },
      ShareAsaleproportionAmount: 0,
      subcheckboxs: true,
      subcheckboxtwo: false,
      titleName: '重复金额占比',
      comprehensivelist: [],
      distributionStuts: 1,
      distributionName: '过去7天',
      tabName: '过去7天',
      tabList: [],
      tableStuts: 1,
      coksstuts: 0,
      validParam: localStorage.getItem('validParam'),
      iconstuts: true,
      iconstuts2: true,
      iconstuts3: true,
      iconstuts4: true,
      iconstuts5: true,
      iconstuts6: true,
      iconstuts7: true,
      startDate: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
      startDate2: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
      startDate3: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
      startDate4: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
      cuntype: 'amount',
      cuntype2: 'amount',
      platformType: 'AvantLink',
      curettime: '',
      tabsalass: null,
      hasplist: [],

      // chartLegend1: ['AvantLink分销金额', 'ShareASale分销金额', 'AvantLink分销订单数', 'ShareASale分销订单数'],
      chartLegend1: ['ShareASale分销金额', 'ShareASale分销订单数'],
      dataList: [], //表单数据
      option1: {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          top: '15%',
          right: '3%',
          bottom: '15%',
          containLabel: true
        },
        legend: {
          bottom: 30,
          data: [],
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            show: true,
            position: 'left',
            name: '订单数',
            interval: 5000,
            minInterval: 1,
            axisLabel: {
              formatter: '{value} '
            }
          },
          {
            type: 'value',
            name: '金额',
            position: 'right',
            interval: 5000,
            axisLabel: {
              formatter: '{value} '
            },
            minInterval: 1,
          },
        ],
        series: [
        ],
        dataZoom: [
          {
            show: false, // 为true 滚动条出现
            realtime: true,
            type: 'slider', // 有type这个属性，滚动条在最下面，也可以不行，写y：36，这表示距离顶端36px，一般就是在图上面。
            height: 10, // 表示滚动条的高度，也就是粗细
            start: 0, // 表示默认展示20%～80%这一段。
            end: 100,
            handleSize: 0,      //两边手柄尺寸
            dataBackground: {
              areaStyle: {
                color: '#fff'
              }
            },
            backgroundColor: '#fff',
            borderColor: "#ffffff",
            fillerColor: '#fff',
            moveOnMouseMove: true, //鼠标移动能触发数据窗口平移
            moveOnMouseMove: true, //鼠标移动能触发数据窗口平移
            zoomLock: true,         //是否只平移不缩放
            showDetail: false, //拖拽时是否展示滚动条两侧的文字
            zoomOnMouseWheel: true,  // 关闭滚轮缩放
            moveOnMouseWheel: true, // 开启滚轮平移
            moveOnMouseMove: true,  // 鼠标移动能触发数据窗口平移 
            bottom: 10,
          },
          {//没有下面这块的话，只能拖动滚动条，鼠标滚轮在区域内不能控制外部滚动条
            type: 'inside',
            xAxis: 0,
            zoomOnMouseWheel: false,  //滚轮是否触发缩放
            moveOnMouseMove: true,  //鼠标滚轮触发滚动
            moveOnMouseWheel: true
          }
        ]
      },
      dataDemo: ['1', '2', '3', '4', '5', '6', '7']
    }
  },
  created(){
    this.hasPlatformList()
  }, 
  mounted() {
    if (this.validParam !== 'zhkbformal') {
      this.$bus.$emit('showNopermiss', true)
    }
    // this.duplicatemap()
    this.queryClicksDetailmap()
    this.queryAmountDataDetailmap()
    this.queryOrderDataDetailmap()
    this.queryAmountCountChartmap()
    this.queryTop5Datamap()
    this.queryAffliateTypeRatemap()
    this.queryRepeatRatemap()

    const datetime = this.$moment().format('YYYY-MM-DD HH:mm:ss') //24小时制
    let mm = datetime.substr(11, 2)
    if (mm > 13) {
      this.curettime = this.$moment().subtract(1, 'days').format('YYYY-MM-DD')
    } else {
      this.curettime = this.$moment().subtract(2, 'days').format('YYYY-MM-DD')
    }
  },



  methods: {
    mouseover(e) {
      this.tabsalass = e
    },
    mouseout() {
      this.tabsalass = null
    },
    // BI看板点击数
    queryClicksDetailmap() {
      QUERYCLICKSDETAIL().then(res => {
        this.hitsList = res.data.body
      })
    },
    //分销金额
    queryAmountDataDetailmap() {
      QUERYAMOUNTDATADETAIL().then(res => {
        this.distribution = res.data.body
      })
    },
    //出单量
    queryOrderDataDetailmap() {
      QUERYORDERDATADETAIL().then(res => {
        this.issue = res.data.body
      })
    },
    // 数据概览
    queryAmountCountChartmap() {
      QUERYAMOUNTCOUNTCHART({ startDate: this.startDate }).then(res => {
        let nowOptions = this.option1
        this.time = res.data.body.xdate
        let arr1 = res.data.body.platforms
        let series = []
        arr1.forEach((item, index) => {
          let color = util.color16()
          nowOptions.legend.data.push(item.name + '分销金额')
          nowOptions.legend.data.push(item.name + '分销订单数')
          series.push({
            name: item.name + '分销金额',
            type: 'bar',
            yAxisIndex: 1,
            barWidth: 16,//柱图宽度
            itemStyle: {    //柱状图的背景色
              normal: {
                color: color
              }
            },
            data: item.amount
          })
          series.push({
            name: item.name + '分销订单数',
            type: 'line',
            symbolSize: 10,
            color: color,
            data: item.count
          })
          nowOptions.xAxis[0].data = this.time
          nowOptions.series = series
        })
        this.$nextTick(() => {
          this.drawPie1(nowOptions)
        })
      })
    },
    // 查询重复订单
    queryDoubleReport() {
      QUERYREPEATORDERCHART({ startDate: this.startDate }).then(res => {
        let nowOptions = this.option1
        let color = util.color16()
        nowOptions.legend.data = ['重复金额', '重复订单数']
        nowOptions.xAxis[0].data = res.data.body.xdate
        let series = [
          {
            name: '重复金额',
            type: 'bar',
            yAxisIndex: 1,
            barWidth: 16,//柱图宽度
            itemStyle: {    //柱状图的背景色
              normal: {
                color: color
              }
            },
            data: res.data.body.repeatAmounts
          },
          {
            name: '重复订单数',
            type: 'line',
            symbolSize: 10,
            color: color,
            data: res.data.body.repeatCounts
          }
        ]
        nowOptions.series = series
        
        this.$nextTick(() => {
          this.drawPie1(nowOptions)
        })
      })
    },

    pzero(e) {
      this.p0stuts = e
      this.inputStsts = 1
      this.inputStsts2 = 1
      if (e == 1) {
        this.p0stutscon = 1
        this.p0stuts = 1
        this.queryAmountCountChartmap()
      } else {
        this.p0stuts = 2
        this.p0stutscon = 2
        this.queryDoubleReport()
      }
    },

    //  【多平台管理】BI看板-联盟客top5
    queryTop5Datamap() {
      QUERYTOP5DATA({ startDate: this.startDate2, type: this.cuntype }).then(res => {
        this.tabList = res.data.body
      })
    },
    // 【多平台管理】BI看板-联盟客类型分销占比
    queryAffliateTypeRatemap() {
      QUERYAFFLIATETYPERATE({ startDate: this.startDate3, type: this.cuntype2 }).then(res => {
        this.comprehensivelist = res.data.body
        this.$nextTick(() => {
          this.drawPie3()
        })
      })
    },
    queryRepeatRatemap() {
      QUERYREPEATRATE({ startDate: this.startDate4, platformType: this.platformType }).then(res => {
        this.ShareAsale = res.data.body
        this.ShareAsaleproportionAmount = res.data.body.amountrate
        this.$nextTick(() => {
          this.drawPie2()
        })
      })
    },
    hasPlatformList() {
      HASPLATFORMLIST().then(res => {
        if (res.data.body) {
          this.hasplist = res.data.body
        }
      })
    },

    tabclick(e) {
      this.tableStuts = e
      if (this.p2stuts == 1) {
        this.cuntype = 'amount'
      } else {
        this.cuntype = 'count'
      }
      if (e == 1) {
        this.tabName = '过去7天'
        this.startDate2 = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
        this.queryTop5Datamap()
      } else if (e == 2) {
        this.tabName = '过去30天'
        this.startDate2 = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
        this.queryTop5Datamap()
      } else if (e == 3) {
        this.tabName = '过去90天'
        this.startDate2 = this.$moment().subtract(90, 'days').format('YYYY-MM-DD')
        this.queryTop5Datamap()
      } else if (e == 4) {
        this.tabName = '过去1年'
        this.startDate2 = this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
        this.queryTop5Datamap()
      }

    },
    psick(e) {
      this.p2stuts = e
      if (e == 1) {
        this.cuntype = 'amount'
        this.queryTop5Datamap()
      } else {
        this.cuntype = 'count'
        this.queryTop5Datamap()
      }
    },
    distributionclik(e) {
      this.distributionStuts = e
      if (this.p1stuts == 1) {
        this.cuntype2 = 'amount'
      } else {
        this.cuntype2 = 'count'
      }
      if (e == 1) {
        this.distributionName = '过去7天'
        this.startDate3 = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
        this.queryAffliateTypeRatemap()
      } else if (e == 2) {
        this.distributionName = '过去30天'
        this.startDate3 = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
        this.queryAffliateTypeRatemap()
      } else if (e == 3) {
        this.distributionName = '过去90天'
        this.startDate3 = this.$moment().subtract(90, 'days').format('YYYY-MM-DD')
        this.queryAffliateTypeRatemap()
      } else if (e == 4) {
        this.distributionName = '过去1年'
        this.startDate3 = this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
        this.queryAffliateTypeRatemap()
      }

    },
    picos(e) {
      this.p1stuts = e
      if (e == 1) {
        this.cuntype2 = 'amount'
        this.queryAffliateTypeRatemap()
      } else {
        this.cuntype2 = 'count'
        this.queryAffliateTypeRatemap()
      }
    },
    // 选择周期
    listclick(e) {
      this.listStuts = e
      if (this.p0stuts == 1) {
        if (e == 1) {
          this.setime = '过去7天'
          this.option1.dataZoom[0].end = 100
          this.startDate = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
        } else if (e == 2) {
          this.setime = '过去30天'
          this.option1.dataZoom[0].end = 50
          this.startDate = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
        } else if (e == 3) {
          this.setime = '过去90天'
          this.option1.dataZoom[0].end = 20
          this.startDate = this.$moment().subtract(90, 'days').format('YYYY-MM-DD')
        } else if (e == 4) {
          this.setime = '过去1年'
          this.option1.dataZoom[0].end = 5
          this.startDate = this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
        }
        this.queryAmountCountChartmap()
      } else {
        if (e == 1) {
          this.setime = '过去7天'
          this.option1.dataZoom[0].end = 100
          this.startDate = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
        } else if (e == 2) {
          this.setime = '过去30天'
          this.option1.dataZoom[0].end = 50
          this.startDate = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
        } else if (e == 3) {
          this.setime = '过去90天'
          this.option1.dataZoom[0].end = 20
          this.startDate = this.$moment().subtract(90, 'days').format('YYYY-MM-DD')
        } else if (e == 4) {
          this.setime = '过去1年'
          this.option1.dataZoom[0].end = 5
          this.startDate = this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
        }
        this.queryDoubleReport()
      }


    },
    nameclick(e, index) {
      this.coksstuts = index
      this.namestuts = index
      this.subcheckboxs = true
      this.subcheckboxtwo = false
      this.platformType = e.channelType
      this.Linkname = e.channelTypeValue
      if (index == 0) {
        this.titleName = '重复金额占比'
        this.queryRepeatRatemap()
      } else {
        this.titleName = '重复金额占比'
        this.queryRepeatRatemap()
      }

    },
    // 重复订单选择时间
    comclick(e) {
      this.listStutscf = e
      this.subcheckboxs = true
      this.subcheckboxtwo = false
      if (e == 1) {
        this.comime = '过去7天'
        this.startDate4 = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
        this.queryRepeatRatemap()
      } else if (e == 2) {
        this.comime = '过去30天'
        this.startDate4 = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
        this.queryRepeatRatemap()
      } else if (e == 3) {
        this.comime = '过去90天'
        this.startDate4 = this.$moment().subtract(90, 'days').format('YYYY-MM-DD')
        this.queryRepeatRatemap()
      } else if (e == 4) {
        this.comime = '过去1年'
        this.startDate4 = this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
        this.queryRepeatRatemap()
      }
      this.$nextTick(() => {
        this.drawPie2()
      })
    },
    ckbox() {
      this.subcheckboxs = !this.subcheckboxs
      QUERYREPEATRATE({ startDate: this.startDate4, platformType: this.platformType }).then(res => {
        this.ShareAsale = res.data.body
        this.ShareAsaleproportionAmount = res.data.body.amountrate
        if (this.subcheckboxs) {
          if (this.namestuts == 0) {
            this.titleName = '重复金额占比'
          } else {
            this.titleName = '重复金额占比'
          }
          this.subcheckboxtwo = false
          this.$nextTick(() => {
            this.drawPie2()
          })
        } else {
          this.subcheckboxtwo = true
          if (this.namestuts == 0) {
            this.titleName = '重复订单占比'
          } else {
            this.titleName = '重复订单占比'
          }

          this.$nextTick(() => {
            this.drawPie2()
          })
        }
      })

    },
    ckboxtwo() {
      this.subcheckboxtwo = !this.subcheckboxtwo
      QUERYREPEATRATE({ startDate: this.startDate4, platformType: this.platformType }).then(res => {
        this.ShareAsale = res.data.body
        this.ShareAsaleproportionAmount = res.data.body.countrate
        if (this.subcheckboxtwo) {
          this.subcheckboxs = false
          if (this.namestuts == 0) {
            this.titleName = '重复订单占比'
          } else {
            this.titleName = '重复订单占比'
          }
          this.$nextTick(() => {
            this.drawPie2()
          })
        } else {
          this.subcheckboxs = true
          if (this.namestuts == 0) {
            this.titleName = '重复金额占比'
          } else {
            this.titleName = '重复金额占比'
          }
          this.$nextTick(() => {
            this.drawPie2()
          })
        }
      })
    },
    iconclick(e) {
      if (e == 1) {
        this.iconstuts = !this.iconstuts
      } else if (e == 2) {
        this.iconstuts2 = !this.iconstuts2
      } else if (e == 3) {
        this.iconstuts3 = !this.iconstuts3
      } else if (e == 4) {
        this.iconstuts4 = !this.iconstuts4
      } else if (e == 5) {
        this.iconstuts5 = !this.iconstuts5
      } else if (e == 6) {
        this.iconstuts6 = !this.iconstuts6
      } else if (e == 7) {
        this.iconstuts7 = !this.iconstuts7
      }

    },
    drawPie1(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart1"));
      // 增加了一个隐藏的x轴，用来控制线图的点的位置
      option.xAxis[1] = {
        type: 'value',
        // max: option.xAxis[0].data.length * 100,
        show: false
      }
      myChart.setOption(option,true);
    },
    drawPie2() {

      // 基于准备好的dom，初始化echarts实例
      let myChart2 = this.$echarts.init(document.getElementById("myChart2"));
      let option = {
        series: [
          {
            type: 'gauge',
            center: ['50%', '50%'],
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 100,
            splitNumber: 12,
            itemStyle: {
              color: '#7892EC'
            },
            progress: {
              show: true,
              width: 30
            },
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: 30
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            anchor: {
              show: true
            },
            title: {
              show: true
            },
            detail: {
              valueAnimation: true,
              width: '100%',
              lineHeight: 15,
              borderRadius: 8,
              offsetCenter: [0, '-15%'],
              fontSize: 12,
              fontWeight: 'bolder',
              formatter: '百分比\n {value}%',
              color: '#7892EC'
            },
            data: [
              {
                value: this.ShareAsaleproportionAmount
              }
            ],

          },
        ]
      };
      myChart2.setOption(option);
    },
    drawPie3() {
      let myChart3 = this.$echarts.init(document.getElementById("myChart3"));
      let arr = []
      if (this.comprehensivelist.length > 0) {
        this.comprehensivelist.forEach((element) => {
          arr.push({
            value: element.typevalue,
            name: element.typekey,
          })
        });
      }

      myChart3.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} {c} ({d}%)",
          textStyle: {
            fontSize: 14
          }
        },
        legend: {
          orient: 'horizontal',
          right: 10,
          top: '5%',
          icon: "rect",
          itemGap: 10,
          x: '50%',
          itemHeight: 10, // 图例icon高度
          itemWidth: 10, // 图例icon宽度
          padding: [20, 5],
          textStyle: {
            fontSize: 10
          }
        },
        // legend: {
        //   right: 10,
        //   top: '5%',
        //   icon: "rect",
        //   x: '50%',
        //   itemGap: 10,
        //   //这里写a
        //   formatter: ["{a|{name}}"].join("\n"),
        //   icon: "circle",
        //   itemWidth: 10,
        //   itemHeight: 10,
        //   padding: [25, 0],
        //   textStyle: {
        //     rich: {
        //       //这里定义a的样式
        //       a: {
        //         width: 70
        //       }
        //     }
        //   }
        // },
        series: [
          {
            type: "pie",
            radius: ["50%", "90%"],
            data: arr,
            color: ['#DDB2F9', '#F89589', '#2CD4D3', '#9577e5', '#FEC776', '#FC6780', '#7892EC', '#B28C68',],
            itemStyle: {
              normal: {
                // borderWidth: 5,
                // borderColor: "#fff",
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },

            center: ['20%', '50%'],
          },

        ],
      });
      myChart3.resize();
    }
  }
}

</script>
<style lang="less" scoped>
.list_top {
  align-items: center;

  p {
    width: 14px;
    height: 14px;
    border: 1px solid;
    line-height: 14px;
    margin: 0 5px;
  }
}

.oocode {
  color: rgba(0, 0, 0, 0.5);
  margin-top: -2px;
}

.listba {
  // background:#a6a8bf;
  background: rgba(166, 168, 191, 0.25) !important;
}

.nologins {
  width: 120px;
  border-radius: 14px;

  .nologins_title {
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(64, 64, 64, 0.25);
    padding-left: 7px;
  }

  .nologins_list {
    width: 100%;
    height: 32px;
    line-height: 32px;
    margin: 10px 0;
  }
}

.top_center1 {
  width: 120px;
  position: absolute;
  right: 0;

  .top_center_two {
    width: 100%;

    .scect {
      border-bottom: 1px solid;
      position: relative;
      align-items: center;
      padding-bottom: 3px;
      margin-top: 5px;

      i {
        position: absolute;
        right: 0;
      }
    }
  }
}

.bulletinBoard {
  // width: 100%;
  // height: 100%;
  padding-top: 69px;
  background: #fafafd;
  box-sizing: border-box;

  .pico {
    background: #be3c6e;
    border-radius: 5px 5px 5px 5px;
    opacity: 1;
    border: 1px solid #be3c6e;
    color: #fff;
  }

  .top {
    width: 100%;
    height: 84px;
    border-bottom: 2px solid rgba(166, 168, 191, 0.25);
    align-items: center;
    position: relative;
    margin-bottom: 24px;

    .top_center {
      width: 300px;
      position: absolute;
      right: 0;

      .top_center_one {
        width: 40%;
        margin-right: 20%;

        .scect {
          border-bottom: 1px solid;
          position: relative;
          align-items: center;
          padding-bottom: 3px;
          margin-top: 5px;

          i {
            position: absolute;
            right: 0;
          }
        }
      }

      .top_center_two {
        width: 40%;

        .scect {
          border-bottom: 1px solid;
          position: relative;
          align-items: center;
          padding-bottom: 3px;
          margin-top: 5px;

          i {
            position: absolute;
            right: 0;
          }
        }
      }
    }
  }

  .top2 {
    width: 100%;
    height: 84px;
    align-items: center;
    position: relative;
    margin-bottom: 24px;

    .top_center {
      width: 120px;
      position: absolute;
      right: 0;

      .top_center_two {
        width: 100%;

        .scect {
          border-bottom: 1px solid;
          position: relative;
          align-items: center;
          padding-bottom: 3px;
          margin-top: 5px;

          i {
            position: absolute;
            right: 0;
          }
        }
      }
    }
  }

  .list {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 34px;
    cursor: pointer;
    transition: all 0.6s;

    .list_li {
      width: 23%;
      height: 176px;
      background: #fff;
      box-shadow: 6px 6px 54px 1px rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(166, 168, 191, 0.25);
      padding: 28px 0 20px 30px;

      .list_center {
        height: 80px;
        align-items: center;

        .yb {
          width: 48%;
        }

        .list_center_top {
          align-items: center;
          position: relative;
        }

        .list_center_img {
          position: absolute;
          top: 7px;

          img {
            width: 42px;
            height: 25px;
          }
        }

        .list_center_text {
          margin-left: 52px;
        }

        .p1 {
          font-size: 35px;
        }
      }

      .list_bott {
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }

  .list :hover {
    transform: scale(1.1);
  }

  .list_li :hover {
    transform: scale(1);
  }

  .zwf {
    width: 100%;
    height: 2px;
    background: rgba(166, 168, 191, 0.25);
    // opacity: 0.25;
  }

  .echart {
    width: 100%;
    height: 600px;
    border: 1px solid rgba(166, 168, 191, 0.25);
    margin-bottom: 34px;
    position: relative;

    .charts {
      width: 100%;
      height: 100%;
      pointer-events: auto;
    }

    .broken {
      position: absolute;
      align-items: center;
      top: 20px;
      left: 70px;

      .broken_input {
        width: 20px;
        height: 20px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .broken_inputtwo {
        width: 20px;
        height: 20px;
        border: 2px solid #be3c6e;
        margin-right: 10px;
      }

      .broken_inputsher {
        width: 30px;
        height: 30px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .broken2 {
      position: absolute;
      align-items: center;
      top: 20px;
      left: 270px;

      .broken_input {
        width: 20px;
        height: 20px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .broken_inputtwo {
        width: 20px;
        height: 20px;
        border: 2px solid #be3c6e;
        margin-right: 10px;
      }

      .broken_inputsher {
        width: 30px;
        height: 30px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .broken4 {
      position: absolute;
      align-items: center;
      top: 20px;
      right: 20px;

      .p1 {
        padding: 9px;
      }

      .p2 {
        width: 2px;
        height: 24px;
        background: rgba(166, 168, 191, 0.25);
        margin: 0 10px;
      }

      .p3 {
        padding: 9px;
      }
    }
  }

  .broken3 {
    position: absolute;
    align-items: center;
    width: 300px;
    bottom: 10px;
    left: 50%;
    margin-left: -150px;

    .broken3_one {
      margin-right: 50px;
    }

    .broken_input {
      margin-right: 10px;
    }
  }

  label {
    display: block;
    height: 20px;
    width: 60px;
    border-radius: 1em;
    border: 0.1px solid gainsboro;
    transition: background-color 1s;
  }

  #turn {
    display: none;
  }

  label::before {
    content: "";
    display: block;
    border-radius: 100%;
    height: 20px;
    width: 20px;
    background-color: #b4b0b0;
    transition: margin 0.5s;
  }

  #turn:checked+label::before {
    margin-left: 38px;
    margin-top: -2px;
    background-color: rgba(252, 103, 128, 1);
    border: 2px solid #fc6780;
    // box-shadow: 1px 1px 10px #888888;
  }

  #turn:checked+label {
    background-color: rgba(252, 103, 128, 0.5);
    // background-image: linear-gradient(to right,#9B63FF,#462188); 背景渐变
  }

  #turn2 {
    display: none;
  }

  label::before {
    content: "";
    display: block;
    border-radius: 100%;
    height: 20px;
    width: 20px;
    background-color: #b4b0b0;
    transition: margin 0.5s;
  }

  #turn2:checked+label::before {
    margin-left: 38px;
    margin-top: -2px;
    background-color: rgba(251, 206, 140, 1);
    border: 2px solid #fbce8c;
    // box-shadow: 1px 1px 10px #888888;
  }

  #turn2:checked+label {
    background-color: rgba(251, 206, 140, 0.5);
    // background-image: linear-gradient(to right,#9B63FF,#462188); 背景渐变
  }

  .imgs_inpusts {
    #turn3 {
      display: none;
    }

    #turn3:checked+label::before {
      margin-left: 38px;
      margin-top: -2px;
      background-color: rgba(120, 146, 236, 1);
      border: 2px solid #7892EC;
      // box-shadow: 1px 1px 10px #888888;
    }

    #turn3:checked+label {
      background-color: rgba(120, 146, 236, 0.5);
      // background-image: linear-gradient(to right,#9B63FF,#462188); 背景渐变
    }
  }

  #turn4 {
    display: none;
  }

  #turn4:checked+label::before {
    margin-left: 38px;
    margin-top: -2px;
    background-color: rgba(120, 146, 236, 1);
    border: 2px solid #7892EC;
    // box-shadow: 1px 1px 10px #888888;
  }

  #turn4:checked+label {
    background-color: rgba(120, 146, 236, 0.5) // background-image: linear-gradient(to right,#9B63FF,#462188); 背景渐变
  }

  .proportion {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 34px;

    .proportion_left {
      width: 55%;
      // border: 1px solid rgba(166,168,191,0.25);
    }

    .proportion_righ {
      width: 35%;

      .top_center {
        width: 120px;

        .top_center_two {
          width: 100% !important;
        }
      }

      // border: 1px solid rgba(166,168,191,0.25);
    }

    .proportion_left_c {
      width: 100%;
      height: 74px;
      border-top: 2px solid rgba(166, 168, 191, 0.25);

      .top {
        border: none;
      }
    }

    .imgs {
      width: 100%;
      height: 260px;
      border: 1px solid rgba(166, 168, 191, 0.25);
      padding-top: 10px;
      margin-top: 20px;

      // position: relative;
      .title_text {
        margin-top: 16px;
      }

      .echatr {
        width: 100%;
        height: 282px;
      }

      .bott_list_top {
        height: 30px;
        padding: 15px 21px 0 30px;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 13px;

        .botts {
          align-items: center;

          p {
            height: 100%;
            line-height: 30px;
          }

          .p1 {
            padding: 0 9px;
          }

          .p2 {
            width: 2px;
            height: 24px;
            background: rgba(166, 168, 191, 0.25);
            margin: 0 10px;
          }

          .p3 {
            padding: 0 9px;
          }
        }
      }

      .bott_list3 {
        width: 100%;
        height: 200px;
      }

      .imgs_inpusts {
        width: 50%;
        height: 1005;
        align-items: center;
        justify-content: center;

        .broken3_one {
          margin-bottom: 23px;
        }

        .broken3_two {
          margin-top: 23px;
        }

        .broken_input {
          margin-right: 25px;
        }
      }
    }
  }

  .bott {
    width: 100%;
    padding-bottom: 34px;
    border-top: 2px solid rgba(166, 168, 191, 0.25);

    .bott_list {
      width: 100%;
      border: 1px solid rgba(166, 168, 191, 0.25);
      padding: 23px 23px 39px 29px;

      .bott_list_top {
        height: 30px;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 13px;

        .botts {
          align-items: center;

          p {
            height: 100%;
            line-height: 30px;
          }

          .p1 {
            padding: 0 9px;
          }

          .p2 {
            width: 2px;
            height: 24px;
            background: rgba(166, 168, 191, 0.25);
            margin: 0 10px;
          }

          .p3 {
            padding: 0 9px;
          }
        }
      }

      .bott_list_center {
        .toop_title {
          // width: 100%;
          height: 37px;
          background: rgba(167, 169, 192, 0.25);
          align-items: center;
          padding-left: 19px;

          .one1 {
            width: 4%;
          }

          .one {
            width: 11%;
          }

          .fooer {
            width: 30%;
          }

          .fooer2 {
            width: 20%;
          }
        }

        .toop_center {
          height: 47px;
          border-bottom: 1px solid #d8dee8;
          align-items: center;
          padding-left: 19px;

          .one1 {
            width: 4%;
          }

          .one {
            width: 11%;
          }

          .sunbiole {
            white-space: nowrap;
            /*内容超宽后禁止换行显示*/
            overflow: hidden;
            /*超出部分隐藏*/
            text-overflow: ellipsis;
            /*文字超出部分以省略号显示*/
          }

          .fooer {
            width: 30%;
            padding-right: 10px;
            box-sizing: border-box;
            overflow: hidden;
            /*超出的部分隐藏起来。*/
            white-space: nowrap;
            /*不让文本换行,在一行显示*/
            text-overflow: ellipsis;
            /*超出显示...*/
          }

          .fooer2 {
            width: 20%;
          }
        }
      }
    }

    .top_center {
      width: 120px;

      .top_center_two {
        width: 100%;
      }
    }

    .tops {
      width: 100%;
      height: 84px;
      // border-bottom: 2px solid rgba(166, 168, 191, 0.25);
      align-items: center;
      position: relative;
      margin-bottom: 24px;

      .top_center {
        width: 120px;
        position: absolute;
        right: 0;

        .top_center_two {
          width: 100%;

          .scect {
            border-bottom: 1px solid;
            position: relative;
            align-items: center;
            padding-bottom: 3px;
            margin-top: 5px;

            i {
              position: absolute;
              right: 0;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_centers {
    width: 1600px;
    margin: 0 auto;
  }

  .titles {
    padding-left: 6px;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_centers {
    width: 1920px;
    margin: 0 auto;
  }

  .titles {
    padding-left: 35px;
  }
}
</style>
<style lang="less">
.bulletinBoard {
  .el-dropdown {
    width: 100%;
  }
}

.el-dropdown-menu__item {
  padding: 0 !important;
  color: #000;
}

.bulletinBoard.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #000;
  background: none;
}
</style>